import type { ModuleId } from "@wato/business-types";

/**
 * OWN-333: the module a notification belongs to (`null` = always shown). Kinds follow the event
 * catalog in `modules/notifications`; unknown kinds stay visible rather than vanish.
 */
export function notificationModule(kind: string): ModuleId | null {
  const area = kind.split(".")[0] ?? "";
  switch (area) {
    case "booking":
      return "bookings";
    case "order":
    case "cart":
    case "discount":
    case "manual_payment":
      return "store";
    case "quote":
      return "quotes";
    case "trip":
      return "travel";
    default:
      return null;
  }
}

/** Keeps notifications whose module is on (the unread count is computed from the kept list). */
export function visibleNotifications<T extends { readonly kind: string }>(
  items: readonly T[],
  isOn: (id: ModuleId) => boolean,
): T[] {
  return items.filter((n) => {
    const m = notificationModule(n.kind);
    return m === null || isOn(m);
  });
}
